interface IGlobalOverlayState {
  displayLoader?: boolean;
  hasAutoCollectParam?: boolean;
  isOtpLoggingIn?: boolean;
  isUrlOtpAuth: boolean;
}

export const shouldShowGlobalOverlay = ({
  displayLoader,
  hasAutoCollectParam,
  isOtpLoggingIn,
  isUrlOtpAuth,
}: IGlobalOverlayState): boolean => {
  if (displayLoader || hasAutoCollectParam) {
    return true;
  }

  return Boolean(isOtpLoggingIn) && !isUrlOtpAuth;
};
